<div fxLayout="row" fxLayoutGap="26px">
  <ng-content [select]="navigation" style="width: 20px !important"></ng-content>
  <ng-content [select]="formSection"></ng-content>
</div>
